import { useNavigate } from 'react-router-dom'
import { ZENDESK_URL } from 'config'

// Custom components
import List, { ListItem } from 'components/List'
import { NewCardButton } from 'components/CardButtons'
import PageWrapper from 'components/PageWrapper'

// Assets
import image1 from 'assets/images/baja-productos.png'
import image2 from 'assets/images/contacto-banco-central.png'
import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'

const INFO = [
  {
    key: 'Directivo Responsable de Protección de los Usuarios de Servicios Financieros',
    value: 'Juan Francisco Salviolo'
  },
  {
    key: 'Titular',
    value: 'Wohlgemuth Matías'
  },
  {
    key: 'Suplente',
    value: 'Rivas Sarquis Martin'
  },
  {
    key: 'Domicilio laboral',
    value: 'Esmeralda 950 - C1007 - CABA'
  },
  {
    key: 'Mail',
    value: 'atencion@waynimovil.com'
  }
]

const ConsumerInformation = () => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_informacion_consumidor' })
  }, [])
  return (
    <PageWrapper
      viewSelected='/centro-de-ayuda'
      className='!px-0 md:px-4'
      title='Información al consumidor'
      noTabBar
    >
      <section className='px-4 mt-4 text-black md:flex md:max-w-564 md:flex-col mb-20 md:mb-5 mx-auto'>
        <div className='space-y-4'>
          <p className='font-medium'>
            Responsables de Atención al Usuario Financiero
          </p>
          <List>
            <>
              {INFO.map((i) => (
                <ListItem key={i.key} name={i.key} value={i.value} />
              ))}
              <p className='mt-4 font-bold text-xs'>
                Podés contar con nuestra ayuda para consultas o reclamos. Vamos
                a responderte en un plazo máximo de 10 días hábiles a partir de
                tu contacto.
              </p>
              <p className='mt-3 pb-4 font-bold text-xs'>
                En caso de no estar de acuerdo con nuestra respuesta o si
                tardamos más de 10 días hábiles en hacerlo, podés comunicarte
                con la Gerencia Principal de Protección a Usuarios Financieros a
                través de su sitio: www.usuariosfinancieros.gob.ar{' '}
                <a href='www.usuariosfinancieros.gob.ar' target='_blank'>
                  (link)
                </a>
                .
              </p>
            </>
          </List>
          <NewCardButton
            onClick={() => {
              trackEvent({
                eventName: 'bille_informacion_consumidor_boton_arrepentimiento'
              })
              window.open(
                `${ZENDESK_URL}/articles/4403307634715--C%C3%B3mo-cancelo-el-pr%C3%A9stamo-que-solicit%C3%A9`,
                '_blank'
              )
            }}
          >
            <span className='text-purple-900 text-xs font-bold'>
              Botón de arrepentimiento
            </span>
          </NewCardButton>
          <NewCardButton
            onClick={() => {
              trackEvent({
                eventName: 'bille_informacion_consumidor_boton_baja_membresía'
              })
              window.open(
                `${ZENDESK_URL}/articles/15473266313371--C%C3%B3mo-puedo-dar-de-baja-mi-suscripci%C3%B3n-a-la-membres%C3%ADa-Wayni`,
                '_blank'
              )
            }}
          >
            <span className='text-purple-900 text-xs font-bold'>
              Solicitar baja de membresía
            </span>
          </NewCardButton>
          <img src={image1} alt='Baja de productos y servicios' />
          <img src={image2} alt='Contacto con el Banco Central' />
        </div>
      </section>
    </PageWrapper>
  )
}

export default ConsumerInformation
